import { render, staticRenderFns } from "./NavbarBreadcrumbs.vue?vue&type=template&id=5132e288"
import script from "./NavbarBreadcrumbs.vue?vue&type=script&lang=js"
export * from "./NavbarBreadcrumbs.vue?vue&type=script&lang=js"
import style0 from "./NavbarBreadcrumbs.vue?vue&type=style&index=0&id=5132e288&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports